import { escapeHTML } from "./utils/common";

export const TOOLTIP_CONTAINER_EL_CLASS_NAME = "vchart-tooltip-container";

export const TOOLTIP_EMPTY_STRING = "";

export const DEFAULT_OPTIONS = {
    offsetX: 10,
    offsetY: 10,
    sanitize: escapeHTML
};
//# sourceMappingURL=constants.js.map
